/**
 * True only for `/sign/<one non-empty segment>` (optional trailing slash).
 */
export function isPublicDocSignaturePath(pathname) {
  const raw = String(pathname ?? "");
  const withoutTrailing = raw.endsWith("/") && raw.length > 1 ? raw.slice(0, -1) : raw;
  const match = /^\/sign\/([^/]+)$/.exec(withoutTrailing);
  return Boolean(match && match[1]);
}
